import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface Message {
  content: string;
  role: string;
}

interface ArgumentSummaryProps {
  argumentSummary: string;
  argumentList: Message[];
  isFinalized: boolean; // New prop to track if the argument is finalized
}

const ArgumentSummary: React.FC<ArgumentSummaryProps> = ({
  argumentSummary,
  argumentList,
  isFinalized,
}) => {
  return (
    <>

      <Paper
        elevation={2}
        sx={{
          mt: 4,
          p: 3,
          maxWidth: 600,
          mx: 'auto',
          textAlign: 'left',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <AutoAwesomeIcon sx={{ color: '#4a346d' }} />
          <Typography variant="h3">
            {isFinalized ? 'Your Argument Summary' : 'Lawyer Analysis'}
          </Typography>
        </Box>

        {/* You could also use variant="body1" directly on the Typography below */}
        <Box sx={{ lineHeight: 1.5 }}>
          {argumentSummary ? (
            <Typography variant="body1">{argumentSummary}</Typography>
          ) : argumentList.length > 0 ? (
            <Typography variant="body1">
              {(() => {
                // Extract the assistant's most recent message
                const assistantMessages = argumentList.filter(
                  (msg) => msg.role === 'assistant'
                );
                if (assistantMessages.length > 0) {
                  const lastAssistantMessage =
                    assistantMessages[assistantMessages.length - 1];
                  return lastAssistantMessage.content;
                } else {
                  return 'Waiting for input.';
                }
              })()}
            </Typography>
          ) : (
            <Typography variant="body1">Start adding details to build your argument.</Typography>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default ArgumentSummary;
